import React from "react";

interface BaseProps {
  baseColor?: string;
  baseHighlightColor?: string;
}

export default function Base({
  baseColor = "#7fff00",
  baseHighlightColor = "#9fff00",
}: BaseProps) {
  // Create a unique ID for the gradient to avoid conflicts when multiple instances are used
  const gradientId = `topEdgeGradient-${Math.random()
    .toString(36)
    .substring(2, 9)}`;

  return (
    <g>
      {/* Using a linear gradient for the top highlight instead of a separate stroke */}
      <defs>
        <linearGradient id={gradientId} x1="0%" y1="0%" x2="0%" y2="30%">
          <stop offset="0%" stopColor={baseHighlightColor} />
          <stop offset="100%" stopColor={baseColor} />
        </linearGradient>
      </defs>

      {/* Single path with gradient fill for the top edge */}
      <path
        d="M -80 50 L 0 100 L 80 50 L 80 70 L 0 120 L -80 70 Z"
        fill={`url(#${gradientId})`}
      />
    </g>
  );
}
